import { schema } from 'normalizr';

const invoicesListSchema = [new schema.Entity('invoices')];
const invoiceItemsSchema = [new schema.Entity('invoiceItems')];

export default {
  invoicesListSchema,
  invoiceItemsSchema,
};
